import { FC } from 'react';
import { Form } from 'antd';
import ButtonC from 'src/components/Forms/Button';
interface SubmitFormInputInterface {
  label: any;
  isProcessing: boolean;
  block?: boolean;
  className?: string;
}
const SubmitFormInput: FC<SubmitFormInputInterface> = ({
  label,
  isProcessing,
  block,
  className
}) => {
  return <Form.Item shouldUpdate>
			{({
      isFieldsTouched,
      getFieldsError
    }) => {
      const disabledForm = !isFieldsTouched(true) || getFieldsError().filter(({
        errors
      }) => errors.length).length > 0;
      return <ButtonC className={className} block={block} type="primary" size="large" htmlType="submit" disabled={disabledForm} loading={isProcessing} text={label} style={{
        borderRadius: '20px',
        fontSize: '14px'
      }} />;
    }}
		</Form.Item>;
};
export default SubmitFormInput;